<div class="ch-ggs-web-suite-aside-box">
  <!-- <div class="btn btn-block btn-iconed btn-iconed-primary btn-iconed-left mb-4">
            @PaymentResources.Chargeable <span class="ml-auto">{{}} @PaymentResources.Credits</span><i aria-hidden="true" class="btn-icon ifc-custom ifc-coin-dollar"></i>
        </div> -->

  <ng-container *ngIf="paymentTranslations$ | async as paymentTranslations">
    <ng-container *ngIf="licenseResult$ | async as licenseResult">
      <div class="ch-ggs-web-suite-boxed-gray">
        <h3>{{ paymentSummaryModel.InformationTitle }}</h3>
        <p [innerHTML]="paymentSummaryModel.InformationText | safeHtml"></p>
        <ng-container
          *ngIf="
            !licenseResult.SubscriptionRequired ||
            (!licenseResult.UserHasSubscription &&
              licenseResult.CreditsRequired)
          "
        >
          <div class="d-flex mt-3">
            <h4>{{ paymentTranslations['Price'] }}</h4>
            <div class="ml-auto">
              <span class="font-weight-bold">
                {{ licenseResult.RequiredCredits }}
                {{ paymentTranslations['Credits'] }}
              </span>
            </div>
          </div>
          <div
            *ngIf="
              licenseResult.AdditionalInformation && toolkey === 'smart-label'
            "
            class="d-flex justify-content-end"
          >
            <small> ({{ licenseResult.AdditionalInformation }}) </small>
          </div>
          <div class="d-flex">
            <h4>{{ paymentTranslations['YourCredits'] }}</h4>
            <div class="ml-auto">
              <span class="font-weight-bold">{{
                licenseResult.IsLoggedIn
                  ? licenseResult.AvailableCredits +
                    ' ' +
                    paymentTranslations['Credits']
                  : '-'
              }}</span>
            </div>
          </div>
          <hazmatsuite-next-license-dependent-button
            [skipCache]="true"
            [model]="creditButtonModel"
            [title]="paymentTranslations['BuyWithCreditsNow']"
            (beforeNavigationAction)="beforeNavigationAction.emit()"
            (submitAction)="buyWithCredits()"
          ></hazmatsuite-next-license-dependent-button>
        </ng-container>
        <ng-container *ngIf="licenseResult.SubscriptionRequired">
          <div class="d-flex mt-3">
            <h3>
              {{ paymentTranslations['Subscription'] }}
              {{ paymentTranslations['PerMonthFrom'] }}
            </h3>
            <div class="ml-auto">
              <span class="font-weight-bold">{{
                licenseResult.SubscriptionPrice | currency: 'CHF'
              }}</span>
            </div>
          </div>
          <hazmatsuite-next-license-dependent-button
            [skipCache]="true"
            [model]="subscriptionButtonModel"
            [title]="paymentTranslations['BuyWithSubscriptionNow']"
            (beforeNavigationAction)="beforeNavigationAction.emit()"
            (submitAction)="buyWithLicense()"
          ></hazmatsuite-next-license-dependent-button>
        </ng-container>

        <ng-container *ngIf="ggsContact$ | async as ggsContact">
          <div class="ch-ggs-web-suite-payment-info">
            <div class="text-muted">
              <i
                aria-hidden="true"
                class="btn-icon ifc-custom ifc-phone mr-2"
              ></i
              >{{ ggsContact.Phonenumber }}
            </div>
            <div class="text-muted">
              <i
                aria-hidden="true"
                class="btn-icon ifc-custom ifc-envelope mr-2"
              ></i
              ><a [href]="'mailto:' + ggsContact.Email" class="text-reset">{{
                ggsContact.Email
              }}</a>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </ng-container>
</div>
